import {useState,useEffect} from 'react'
import axios from '../../../axios'

const SectorDropdown = ({value,handleInputChange,dont ,centre,imp}) => {
    const [sectors, setSectors] = useState([]);
    const [err,setErr]=useState(false)
    useEffect(() => {
      const fetchSectors = async () => {
        try {
          const response =centre? await axios.get(`/scheme/getschemes/${centre}`):await axios.post('/scheme/getall')
          // Replace '/api/sectors' with your actual API endpoint
          // console.log(response.data)
          setSectors(response.data);
        } catch (error) {
          console.error('Error fetching scheme:', error);
        }
      };
  
      fetchSectors();
    }, [centre]);
  
    return (
      <div className="flex flex-col">
        <label htmlFor='sector'className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Scheme Name&nbsp;{imp&& <span className='text-red-600'>*</span>}</label>
        {err?(<input 
        id='sector'
        name='sector'
        type='text'
        disabled={dont}
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}

       value={value}
       onChange={handleInputChange}/>):(<>
        <select
        value={value}
        onChange={handleInputChange}
        disabled={dont}
        className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${err&&'border-red-600'}`}
>
        <option value="">All</option>

          {sectors.map((scheme,index) => (
            <option key={index} value={scheme.scheme_id}>
              {scheme.scheme_name}
            </option>
          ))}
        </select>
        </>)}
        
      </div>
    );
  };
  
  export default SectorDropdown;